import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const DescriptionWrapper = styled.div`
  padding: 0 0 29px;

  button {
    font-size: 15px;
    font-weight: 700;
    border: 0;
    padding: 0;
    height: auto;
    line-height: 1;
    box-shadow: none;
    text-shadow: none;
    color: ${themeGet('primary.0', '#194AB9')};

    &::after {
      content: none;
    }
  }

  .ant-typography {
    font-size: 15px;
    font-weight: 400;
    color: ${themeGet('text.0', '#2C2C2C')};
  }

  .ant-typography-expand {
    display: none;
  }

  @media only screen and (max-width: 480px) {
    .marinaLocation {
      font-size: 15px;
    }
    .marinaName {
      font-size: 25px;
    }
  }
`;

export default DescriptionWrapper;
